<template>
  <el-dialog :title="$t('listOwnerCar.importCarTitle')" :visible.sync="visible" width="600px" @close="resetForm">
    <el-form :model="form" label-width="120px" class="text-left">
      <!-- 导入模式选择 -->
      <el-form-item :label="$t('listOwnerCar.importMode')">
        <el-select v-model="form.importMode" @change="handleModeChange" style="width:100%">
          <el-option value="ownerCar" :label="$t('listOwnerCar.importModeOwnerCar')"></el-option>
          <el-option value="roomCar" :label="$t('listOwnerCar.importModeRoomCar')"></el-option>
          <el-option value="carOnly" :label="$t('listOwnerCar.importModeCarOnly')"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('listOwnerCar.selectFile')">
        <el-upload class="upload-demo" action="" :on-change="handleFileChange" :auto-upload="false"
          :show-file-list="false">
          <el-button size="small" type="primary">{{ $t('listOwnerCar.selectFile') }}</el-button>
          <div slot="tip" class="el-upload__tip">
            {{ fileName || $t('listOwnerCar.fileRequired') }}
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item :label="$t('listOwnerCar.downloadTemplate')">
        <div>
          {{ $t('listOwnerCar.downloadFirst') }}
          <el-link type="primary" :href="currentTemplate" target="_blank">
            {{ $t('listOwnerCar.importTemplate') }}
          </el-link>
          <span>{{ $t('listOwnerCar.prepareData') }}</span>
        </div>
        <div v-if="form.importMode === 'ownerCar'" class="template-desc">
          <span class="desc-text">{{ $t('listOwnerCar.importModeOwnerCarDesc') }}</span>
        </div>
        <div v-if="form.importMode === 'roomCar'" class="template-desc">
          <span class="desc-text">{{ $t('listOwnerCar.importModeRoomCarDesc') }}</span>
        </div>
        <div v-if="form.importMode === 'carOnly'" class="template-desc">
          <span class="desc-text">{{ $t('listOwnerCar.importModeCarOnlyDesc') }}</span>
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="importData" :loading="loading">
        {{ $t('listOwnerCar.import') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importData } from '@/api/car/listOwnerCarApi'

// 导入模式配置
const IMPORT_MODE_CONFIG = {
  ownerCar: {
    importAdapt: 'importOwnerCar',
    template: '/import/importCar.xlsx',
    logType: 'importOwnerCar'
  },
  roomCar: {
    importAdapt: 'importOwnerCarByRoom',
    template: '/import/importCarByRoom.xlsx',
    logType: 'importOwnerCarByRoom'
  },
  carOnly: {
    importAdapt: 'importCarOnly',
    template: '/import/importCarOnly.xlsx',
    logType: 'importCarOnly'
  }
}

export default {
  name: 'ImportOwnerCar',
  data() {
    return {
      visible: false,
      loading: false,
      file: null,
      fileName: '',
      form: {
        importMode: 'ownerCar'
      },
      currentTemplate: '/import/importCar.xlsx'
    }
  },
  methods: {
    open() {
      this.visible = true
      this.form.importMode = 'ownerCar'
      this.currentTemplate = '/import/importCar.xlsx'
    },

    handleModeChange(mode) {
      const config = IMPORT_MODE_CONFIG[mode]
      if (config) {
        this.currentTemplate = config.template
      }
    },

    handleFileChange(file) {
      this.file = file.raw
      this.fileName = file.name
    },

    async importData() {
      if (!this.file) {
        this.$message.warning(this.$t('listOwnerCar.fileRequired'))
        return
      }

      if (!this.checkFileType(this.fileName)) {
        this.$message.warning(this.$t('listOwnerCar.invalidExcel'))
        return
      }

      if (!this.checkFileSize(this.file.size)) {
        this.$message.warning(this.$t('listOwnerCar.fileSizeExceed'))
        return
      }

      const config = IMPORT_MODE_CONFIG[this.form.importMode]
      if (!config) {
        this.$message.error('未知的导入模式')
        return
      }

      this.loading = true
      try {
        const response = await importData({
          file: this.file,
          importAdapt: config.importAdapt
        })

        this.$message.success(this.$t('common.operationSuccess'))
        this.$emit('success')
        this.visible = false
        this.$router.push(`/views/system/assetImportLogDetail?logId=${response.logId}&logType=${config.logType}`)
      } catch (error) {
        console.error('导入失败:', error)
        this.$message.error(error)
      } finally {
        this.loading = false
      }
    },

    checkFileType(fileName) {
      const ext = fileName.split('.').pop().toLowerCase()
      return ['xlsx', 'xls'].includes(ext)
    },

    checkFileSize(size) {
      const maxSize = 10 * 1024 * 1024 // 10MB
      return size <= maxSize
    },

    resetForm() {
      this.file = null
      this.fileName = ''
      this.form.importMode = 'ownerCar'
    }
  }
}
</script>

<style scoped>
.template-desc {
  margin-top: 5px;
}
.desc-text {
  color: #909399;
  font-size: 12px;
}
</style>
